export const GOOGLE_ANALYTICS_TRACKING_CODE = process.env.GOOGLE_ANALYTICS_TRACKING_CODE;
export const BUGSNAG_API_KEY = process.env.BUGSNAG_API_KEY;
export const ENVIRONMENT = process.env.ENVIRONMENT || process.env.NODE_ENV;
